module.exports = "images/reglage.d737eb78.png";